import React from 'react';
import Svg from "../Svg";
import { translate } from '../../Services/translation';

/**
 *
 * @param {ProductBundleItem[]} bundleItems
 * @param {boolean} tabIndex
 * @param iconClassName
 * @returns {JSX.Element|null}
 * @constructor
 */
const ProductBundleContents = ({ bundleItems, tabIndex, iconClassName = '', useLinks = false }) => {
    if (!Array.isArray(bundleItems) || bundleItems.length === 0) {
        return null;
    }

    return <table className="product-bundle-contents">
        <caption className="table-caption">
            {translate('muha.bundledproducts.bundledcontents.label')}
        </caption>
        <tbody>
            {bundleItems.map((item, index) =>
                <tr key={`bundle-item-${item.id}-${index}`} tabIndex={tabIndex ? '0' : '-1'}>
                    <td>{item.quantity}</td>
                    <td className="text--center"><Svg icon="close" extraClass={iconClassName} label="st"/></td>
                    <td>
                    {useLinks ? (
                        <a href={item.url} target="_blank">{item.name}</a>
                    ) : (
                        <span>{item.name}</span>
                    )}
                    </td>
                </tr>
            )}
        </tbody>
    </table>
}
export default ProductBundleContents;
